var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('div',{staticClass:"rounded-full my-auto"},[_c('img',{staticClass:"rounded-full",class:_vm.big
        ? 'w-40 h-40 2xl:w-60 2xl:h-60'
        : 'w-30 h-30 leading-30 2xl:w-45 2xl:h-45 2xl:leading-45',attrs:{"src":_vm.image,"alt":_vm.name}})]):_c('div',{staticClass:"text-white rounded-full flex justify-center items-center",class:[
    _vm.color ? ("bg-" + _vm.color) : ("bg-" + _vm.randomColor),
    _vm.big
      ? 'w-40 h-40 2xl:w-60 2xl:h-60'
      : 'w-30 h-30 leading-30 2xl:w-45 2xl:h-45 2xl:leading-45' ]},[_c('span',{staticClass:"font-medium",class:{ 'text-2xl': _vm.big }},[_vm._v(" "+_vm._s(_vm.name.charAt(0).toUpperCase())+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }